import { startCase } from 'lodash';
import type { ReactElement } from 'react';

import { Box, Grid, Heading, Text } from '@simplywallst/ui-core';

import { pluralise } from '@/utilities/pluralise';

import RootTooltip from '@/components/Tooltip';

import type { AggregatePortfolio } from '@/hooks/portfolio/useAggregatePortfolio';

interface Props {
  aggregatePortfolio: AggregatePortfolio | null;
  section: 'value' | 'future' | 'past' | 'health' | 'dividend';
  children: ReactElement;
}

export const Tooltip = ({ aggregatePortfolio, section, children }: Props) => (
  <RootTooltip
    title={
      <Grid
        minWidth={260}
        templateColumns="auto max-content"
        alignItems="center"
        justifyContent="space-between"
        data-cy-id="snowflake-tooltip"
      >
        <Box>
          <Heading as="h3" typography="smallStrong">
            Average {startCase(section)} Score
          </Heading>
          {aggregatePortfolio ? (
            <Text typography="tiny" color="whiteRGBA" opacity={0.5}>{`${
              aggregatePortfolio.analysis.holdingsCount
            } ${pluralise(
              aggregatePortfolio.analysis.holdingsCount,
              'holding',
              'holdings'
            )}`}</Text>
          ) : null}
        </Box>
        <Text typography="smallStrong" color="whiteRGBA" opacity={0.5}>
          <Text
            as="span"
            typography="megaStrong"
            color="white"
            data-cy-id="score"
          >
            {aggregatePortfolio
              ? aggregatePortfolio.snowflake.scores[section] || 0
              : 0}
          </Text>
          {` `}/ 6
        </Text>
      </Grid>
    }
    placement="top"
  >
    <g>{children}</g>
  </RootTooltip>
);
